import service from '@/plugins/service'

const baseURL = 'warning/device'
const customWarning = 'warning/custom'
const schedule = '/warning/custom/schedule'

export default {}

export const getWarningList = (params, data = {}) => {
  return service({
    url: `${baseURL}`,
    method: 'POST',
    params,
    data
  })
}


export const exportWarningList = (params, data) => {
  return service({
    url: `${baseURL}/export`,
    method: 'POST',
    params,
    data,
    responseType: 'blob'
  })
}

export const getWarningInfo = params => {
  return service({
    url: `${baseURL}`,
    method: 'GET',
    params
  })
}

export const addWarningNote = data => {
  return service({
    url: `${baseURL}/note`,
    method: 'POST',
    data
  })
}

export const updateWarningNote = data => {
  return service({
    url: `${baseURL}/note`,
    method: 'PUT',
    data
  })
}

export const deleteWarningNote = id => {
  return service({
    url: `${baseURL}/note`,
    params: {
      id
    },
    method: 'DELETE'
  })
}

export const getStationOrDeviceWarningList = params => {
  return service({
    url: `/warning`,
    method: 'GET',
    params
  })
}

export const getWarningTemplateList = type => {
  return service({
    url: '/warning/template',
    method: 'GET',
    params: {
      type
    }
  })
}

export const deleteWarningTemplate = id => {
  return service({
    url: '/warning/template',
    method: 'DELETE',
    params: {
      id
    }
  })
}

export const addWarningTemplate = data => {
  return service({
    url: '/warning/template',
    method: 'POST',
    data
  })
}

export const updateWarningTemplate = data => {
  return service({
    url: '/warning/template',
    method: 'PUT',
    data
  })
}

export const addWarning = data => {
  return service({
    url: '/warning',
    method: 'POST',
    data
  })
}

export const updateWarning = data => {
  return service({
    url: '/warning',
    method: 'PUT',
    data
  })
}

export const getWarning = id => {
  return service({
    url: '/warning',
    method: 'GET',
    params: {
      id
    }
  })
}

export const delWarning = id => {
  return service({
    url: '/warning',
    method: 'DELETE',
    params: {
      id
    }
  })
}

export const getWarningRecordList = params => {
  return service({
    url: '/warning/record/user',
    method: 'GET',
    params
  })
}

export const getWarningRecordListByStation = params => {
  return service({
    url: '/warning/record',
    method: 'GET',
    params
  })
}

export const noticeWarningRecord = id => {
  return service({
    url: `/warning/record/notice/${id}`,
    method: 'PUT'
  })
}

export const deleteWarningRecord = id => {
  return service({
    url: `/warning/record/notice/${id}`,
    method: 'DELETE'
  })
}

export const addWarningIgnore = data => {
  return service({
    url: 'warning/device/ignore',
    method: 'POST',
    data
  })
}

export const updateWarningIgnore = data => {
  return service({
    url: 'warning/device/ignore',
    method: 'PUT',
    data
  })
}

export const deleteWarningIgnore = id => {
  return service({
    url: 'warning/device/ignore',
    method: 'DELETE',
    params: {
      id
    }
  })
}

export const deleteErrorRecord = id => {
  return service({
    url: '/warning/device',
    method: 'DELETE',
    params: {
      id,
      type: 'ERROR'
    }
  })
}

export const addWarningRecord = data => service({
  url: `${baseURL}/record`,
  method: 'POST',
  data
})

export const updateWarningRecord = data => service({
  url: `${baseURL}/record`,
  method: 'PUT',
  data
})

export const deleteWarningRecordNote = id => service({
  url: `${baseURL}/record`,
  method: 'DELETE',
  params: { id }
})

export const searchIgnoreList = data => service({
  url: `${baseURL}/ignore/list`,
  method: 'POST',
  data
})
export const pageIgnoreList = (current,pageSize,data) => service({
  url: `${baseURL}/ignore/page?current=${current}&pageSize=${pageSize}`,
  method: 'POST',
  data
})
export const getIgnoreLog = (deviceCode,startTime,endTime) => service({
  url: `${baseURL}/ignore/log?deviceCode=${deviceCode}&startTime=${startTime}&endTime=${endTime}`,
  method: 'GET',

})


export const restoreIgnoreWarning = (warningCode, deviceId) => service({
  url: `${baseURL}/ignore/restore`,
  method: 'PUT',
  params: {
    warningCode,
    deviceId
  }
})

export const getCustomWarnings = (current, pageSize, data) => service({
  url: `${customWarning}/query`,
  method: "POST",
  params: {
    current,
    pageSize
  },
  data
})

export const getCustomWarning = id => service({
  url: `${customWarning}`,
  method: "GET",
  params: {
    id
  }
})

export const postCustomWarning = data => service({
  url: `${customWarning}`,
  method: "POST",
  data
})

export const putCustomWarning = data => service({
  url: `${customWarning}`,
  method: "PUT",
  data
})

export const deleteCustomWarning = id => service({
  url: `${customWarning}`,
  method: "DELETE",
  params: {
    id
  }
})

export const getSchedules = () => service({
  url: `${schedule}/list`,
  method: "GET"
})

export const postSchedule = data => service({
  url: `${schedule}`,
  method: "POST",
  data
})

export const putSchedule = data => service({
  url: `${schedule}`,
  method: "PUT",
  data
})

export const deleteSchedule = id => service({
  url: `${schedule}`,
  method: "DELETE",
  params: {
    id
  }
})

export const enableSchedule = (id, enabled) => service({
  url: `${schedule}/enabled`,
  method: "PUT",
  params: {
    id,
    enabled
  }
})

export const getDeviceWarningInfo = deviceId => service({
  url: `${baseURL}/`,
  method: "GET",
  params: {
    deviceId
  }
})

export const postFields = data => service({
  url: "/warning/field/update",
  method: "POST",
  data
})

export const getFields = username => service({
  url: "/warning/field/get",
  method: "GET",
  params: {
    username
  }
})

export const clearFields = username => service({
  url: "/warning/field/clear",
  method: "DELETE",
  params: {
    username
  }
})

export const postDeviceAllWarnings = (current, pageSize, data) => service({
  url: `${baseURL}/allWarning`,
  method: "POST",
  params: {
    current,
    pageSize
  },
  data
})

export const postExportDeviceAllWarnings = data => service({
  url: `${baseURL}/allWarning/export`,
  method: "POST",
  data,
  responseType: "blob"
})

export const getWarningHistory = params => service({
  url: "/warning/history/list",
  method: "GET",
  params
})